import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const RefreshIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "refresh",
  "RefreshIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M13.6668 3.88979C12.3949 2.1391 10.3311 1 8.00017 1C4.38262 1 1.40673 3.74361 1.03846 7.26397L0.969099 7.92702L2.2952 8.06574L2.36456 7.4027C2.66255 4.55417 5.07244 2.33333 8.00017 2.33333C10.0273 2.33333 11.807 3.39792 12.8087 5H10.3335V6.33333H15.0002V1.66667H13.6668V3.88979ZM13.7052 7.93426L13.6358 8.5973C13.3378 11.4458 10.9279 13.6667 8.00017 13.6667C5.97304 13.6667 4.19339 12.6021 3.1917 11H5.66684V9.66667H1.00017V14.3333H2.33351V12.1102C3.60547 13.8609 5.6693 15 8.00017 15C11.6177 15 14.5936 12.2564 14.9619 8.73603L15.0312 8.07298L13.7052 7.93426Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default RefreshIcon;
